import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email("Invalid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});

export const registerSchema = z
  .object({
    email: z.string().email("Invalid email address"),
    password: z.string().min(6, "Password must be at least 6 characters"),
    confirmPassword: z.string(),
    name: z.string().min(2, "Name must be at least 2 characters"),
    phone: z.string().optional(),
    country: z.string().min(1, "Country is required"),
    role: z.enum(["fan", "organizer", "manager"]),
  })
  .refine(data => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export const eventSchema = z.object({
  title: z.string().min(3, "Title must be at least 3 characters"),
  description: z.string().min(10, "Description must be at least 10 characters"),
  groundId: z.string().min(1, "Ground is required"),
  datetime: z.string().min(1, "Date and time is required"),
  duration: z.number().min(30, "Duration must be at least 30 minutes"),
  ticketTypes: z
    .array(
      z.object({
        name: z.string().min(1, "Ticket type name is required"),
        price: z.number().min(0, "Price must be positive"),
        quantity: z.number().min(1, "Quantity must be at least 1"),
      })
    )
    .min(1, "At least one ticket type is required"),
});

export const groundSchema = z.object({
  name: z.string().min(3, "Ground name must be at least 3 characters"),
  type: z.enum(["soccer", "cricket", "multipurpose"]),
  location: z.object({
    country: z.string().min(1, "Country is required"),
    city: z.string().min(1, "City is required"),
    address: z.string().min(5, "Address must be at least 5 characters"),
    coordinates: z.array(z.number()).length(2),
  }),
  capacity: z.number().min(1, "Capacity must be at least 1"),
  amenities: z.array(z.string()),
  pricing: z.object({
    basePrice: z.number().min(0, "Base price must be positive"),
    currency: z.string().min(1, "Currency is required"),
  }),
});

export const profileSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  phone: z.string().optional(),
  country: z.string().min(1, "Country is required"),
  preferences: z.object({
    notifications: z.object({
      email: z.boolean(),
      push: z.boolean(),
      sms: z.boolean(),
    }),
    language: z.string(),
    currency: z.string(),
  }),
});
